import React from "react";
import {useSelector} from "react-redux";

export default function () {
    const question_practice_skills = useSelector(state => state.question_practice_skills);
    const practice_skills_ids = Array.from(question_practice_skills.map(qps => qps.practice_skill_id));
    const practice = useSelector(state => state.practice);
    const practice_skills = practice.practice_skills.filter(ps => practice_skills_ids.includes(ps.id));

    return (
        <div className='mt-4'>
            <h3>Skills Reference</h3>
            <div className="table-responsive mt-4">
                <table className='table table-bordered table-sm'>
                    <thead>
                    <tr>
                        <th>Skill code</th>
                        <th>Skill name</th>
                        <th>Skill description</th>
                    </tr>
                    </thead>
                    <tbody>
                    {practice_skills.map(practice_skill => {
                        return (
                            <tr key={practice_skill.id}>
                                <td>{practice_skill.code}</td>
                                <td>{practice_skill.name}</td>
                                <td>{practice_skill.description}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
